import ShopaholicSearch from '@lovata/shopaholic-search';
import Helper from '@lovata/popup-helper';
import tippy from 'tippy.js';

export default new class Search {
  constructor() {
    this.panelSelector = 'search-panel';
    this.panelOpenSelector = 'search-panel_hidden';
    this.drawerBtnSelector = 'js-search-popup';
    this.drawerParentSelector = 'header__search';
    this.drawerCloseSelector = 'search-panel__close';
    this.searchResultWrapper = 'search-panel__result';
    this.searchInputSelector = 'search-panel__input-field';
    this.preLoaderSelector = '.search-panel__preloader';
    this.searchResultDesktopWrapper = 'search-panel__result-open';
    this.searchNode = this.initSearchTippy();

    this.init();
    this.handler();
  }

  init() {
    this.obSearchHelper = new ShopaholicSearch();
    this.obSearchHelper.setAjaxRequestCallback((obRequest) => {
      /* eslint-disable no-param-reassign */
      obRequest.update = { 'header/search/search-panel/search-panel-result': `.${this.searchResultWrapper}` };
      obRequest.loading = this.preLoaderSelector;
      obRequest.beforeSend = () => {
        this.searchNode.hide();
      };
      obRequest.complete = () => {
        this.inputHandler();
      };
      /* eslint-enable */

      return obRequest;
    });
    this.obSearchHelper.init();
  }

  handler() {
    const modal = document.querySelector(`.${this.panelSelector}`);
    const searchInput = document.querySelector(`.${this.searchInputSelector}`);

    $(document).on('click', `.${this.drawerBtnSelector}`, ({ currentTarget }) => {
      const btn = document.querySelector(`.${this.drawerCloseSelector}`);
      const panel = $(currentTarget).parents(`.${this.drawerParentSelector}`).children(`.${this.panelSelector}`);
      const isOpen = !panel.hasClass(this.panelOpenSelector);

      Helper.setBodyScrollState(isOpen);
      Helper.overlayHandler(!isOpen, btn, modal);

      panel.toggleClass(this.panelOpenSelector);

      setTimeout(() => {
        Helper.focusTrapManager(!isOpen, modal);
      }, 300);
      this.clearSearchInput(isOpen);
    });

    searchInput.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
      }

      // this.setProps().desktopSearch(this.searchNode);
    });
  }

  clearSearchInput(isOpen) {
    if (!isOpen) return;

    $(`.${this.searchInputSelector}`).val('');

    const searchResultWrapper = $(`.${this.searchResultWrapper}`);

    const childrenNode = searchResultWrapper.children();

    if (!childrenNode.length) return;

    childrenNode.remove();
  }

  initSearchTippy() {
    const searchInput = document.querySelector(`.${this.searchInputSelector}`);
    const inputNode = tippy(searchInput);

    return inputNode;
  }

  setProps() {
    const html = `<ul class="search-panel__result-open" aria-live="polite">${$(`.${this.searchResultWrapper}`).html()}</ul>`;

    const that = this;

    this.props = {
      animation: 'scale-subtle',
      content: html,
      allowHTML: true,
      placement: 'bottom-start',
      interactive: true,
      boundary: 'viewport',
      hideOnClick: 'toggle',
      appendTo: document.body,
      interactiveBorder: 20,
      interactiveDebounce: 25,
      offset: [0, 0],
      moveTransition: 'transform 0.2s ease-out',
      onShow() {
        that.adaptSearchPanelWidth();
      },
    };

    return this;
  }

  desktopSearch(inputNode) {
    inputNode.setProps(this.props);
  }

  adaptSearchPanelWidth() {
    // setTimeout(() => {
    $(`.${this.searchResultDesktopWrapper}`).css({
      width: $('._shopaholic-search-input').outerWidth() - 15,
    });
    // }, 100);
  }

  inputHandler() {
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.setProps().desktopSearch(this.searchNode);
      this.searchNode.show();

      this.adaptSearchPanelWidth();
    }, 100);
  }
}();
